
export const Gallery = ({ img1, img2, img3 }) => {
    return (
        <>
            <section className="gallery py-5">
                <div className="container">
                    <div className="row">
                        <div className="col-4 mb-auto">
                            <img data-aos="fade-down"    className="img-fluid" src={img1} alt=""></img>
                        </div>
                        <div className="col-4">
                            <img      className="img-fluid" src={img2} alt=""></img>
                        </div>
                        <div className="col-4 mt-auto">
                            <img data-aos="fade-down"    className="img-fluid" src={img3} alt=""></img>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
